export function cn(...inputs) {
    return inputs
        .flat(Infinity)
        .filter(Boolean)
        .join(' ');
}
//# sourceMappingURL=cn.js.map